import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NavigationCtlEffects } from './+state/navigation-ctl.effects';
import { initialStateNavigation } from './+state/navigation-ctl.init';
import { localStorageSyncReducer } from './+state/navigation-ctl.metareducer';
import * as fromNavigationCtl from './+state/navigation-ctl.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromNavigationCtl.NAVIGATION_CTL_FEATURE_KEY, fromNavigationCtl.navigationCtlReducer, {
      metaReducers: [localStorageSyncReducer],
      initialState: initialStateNavigation
    }),
    EffectsModule.forFeature([NavigationCtlEffects])
  ]
})
export class CoreDataAccessNavigationCtlModule {}
